import { ApolloError } from '@apollo/client';
import { Box } from '@bechtel/gds';
import { Equipment } from '@bechtel/sr-types';
import { FC, Suspense } from 'react';
import {
  ContentContainerStyled,
  ErrorBoundary,
  MetadataText,
  RightPanelSkeleton,
  SuspenseLoader,
  UserInfo,
  useTableMetadataContext,
} from '~/components';

interface AdditionalInfoProps {
  data: Equipment;
  loading?: boolean;
  error?: ApolloError | undefined;
}

export const AdditionalInfo: FC<AdditionalInfoProps> = ({ data, loading, error }) => {
  const tableMetadata = useTableMetadataContext();

  if (loading || !tableMetadata) return <RightPanelSkeleton />;

  if (error) {
    return (
      <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
        {error.message}
      </Box>
    );
  }
  return (
    <Box
      alignItems={{ sm: 'flex-start' }}
      flexDirection={{ sm: 'column' }}
      flexGrow={{ sm: 1 }}
      css={{ overflow: 'hidden' }}
    >
      <ContentContainerStyled>
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader />}>
            <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
              {data && (
                <Box
                  mt={{ sm: '500' }}
                  mb={{ sm: '300' }}
                  pr={{ sm: '300' }}
                  flexDirection={{ sm: 'column' }}
                  css={`
                    ${({ theme }) => `border-bottom: 1px solid ${theme.colors.grey[200]};`}
                  `}
                >
                  <Box
                    py={{ sm: '400' }}
                    css={`
                      ${({ theme }) => `border-bottom: 1px solid ${theme.colors.primary[700]};`}
                    `}
                  >
                    <MetadataText
                      size="400"
                      color="primary.700"
                      weight="600"
                      metadataTable={tableMetadata}
                      memberName="updatedBy"
                    />
                  </Box>
                  <Box pr={{ sm: '300' }}>
                    <UserInfo
                      updatedBy={data?.updatedBy}
                      userAccount={data?.updatedByUser ?? undefined}
                      updatedTime={data?.updatedTime}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Suspense>
        </ErrorBoundary>
      </ContentContainerStyled>
    </Box>
  );
};
